// External Dependencies:
import React from 'react'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import Editable from 'church-theme-library/components/Editable/Editable'
import Image from 'church-theme-library/components/Image/Image'

class EmailNewsletterSignup extends React.Component {
	render() {
		const { contentId, sectionId, data } = this.props

		if ( ! data ) {
			return null
		}

		const fullData = {
			title: data.title || '',
			url: data.url || '', // Default url.
			button: data.button || {} // Customised.
		}

		return (
			<div className="section-call-to-action-heading-link">
				<div className="-inner">
					<div className="-title">
						<Editable
							element="h2"
							id={ contentId }
							sectionId={ sectionId }
							sectionType={ data.type }
							sectionDataId="title"
							content={ fullData.title }
						/>
					</div>

					<div className="-action">
						<Editable
							id={ contentId }
							sectionId={ sectionId }
							sectionType={ data.type }
							sectionDataId="button"
							linkUrl={ fullData.button.url }
							linkText={ fullData.button.text }
						/>

						{ ( fullData.button && fullData.button.text ) &&
							<a href={ fullData.button.url } className="button">{ fullData.button.text }</a>
						||
							<a href={ fullData.url } className="button">Subscribe</a>
						}
					</div>
				</div>
			</div>
		)
	}
}

export default EmailNewsletterSignup
